module.exports = __webpack_public_path__ + "static/media/ALTHAR_Electronic-Medical-Records.6db8ce99.png";